<div class="summary-widgets" [class.grid-layout]="layout === 'grid'" [class.horizontal-layout]="layout === 'horizontal'">
  @for (card of cards; track card.title) {
  <div class="widget">
    <div class="widget-header">
      @if (card.icon) {
      <mat-icon>{{ card.icon }}</mat-icon>
      }
      <span>{{ card.title }}</span>
    </div>
    <div class="widget-value">{{ card.value }}</div>
    @if (card.subtitle) {
    <div class="widget-subtitle">{{ card.subtitle }}</div>
    }
  </div>
  }
</div>